import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { MomentModule } from 'ngx-moment'

import { UtilCommonModule } from 'common/util/module'
import { EntityListModule } from 'common/entityList'
import { LocaleModule } from 'common/locale/module'
import { MediaPermissionsModule } from 'media.permissions'

import { SharedLinkComponent } from './components/sharedLink.component'
import { SharingLinksReadyModalComponent } from './components/sharingLinksReadyModal.component'
import { SharingModalComponent } from './components/sharingModal.component'
import { SharingCreateLinkModalComponent } from './components/sharingCreateLinkModal.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EntityListModule,
    UtilCommonModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbModalModule,
    NgbDatepickerModule,
    MomentModule,
    LocaleModule.forChild(),
    MediaPermissionsModule,
  ],
  declarations: [
    SharedLinkComponent,
    SharingModalComponent,
    SharingLinksReadyModalComponent,
    SharingCreateLinkModalComponent,
  ],
  exports: [
    SharedLinkComponent,
    SharingCreateLinkModalComponent,
  ],
})
export class MediaSharingModule { }
